// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__cYRES","title":"Courses_title__OCUbo"};